import { Component, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentMethodsService } from '../../../../core/services/impl/section-services/method-payments/payment-methods.service';
import { MetricsService } from '../../../services/metrics.service';
import { MetricsType } from '../../../components/models/metrics/metrics-type.enum';
import { CustomMetricsName } from '../../../components/models/metrics/custom-metrics-name.enum';
import { StepKey } from '../../../../core/enums/step-key.enum';
import {TranslateService} from '@ngx-translate/core';
import {GoogleAnalyticsEventsService} from '../../../services/google-analytics-events.service';
import {Ga4EventPayload} from '../../../../core/models/ga4-event-payload';
import {GA4EventKey} from '../../../../core/consts/ga4-event-key.enum';
import {FormFieldService} from '../../../services/form-field.service';
import {PaymentMethod} from '../../../../core/consts/payment-method.enum';

@Component({
  selector: 'app-method-payments-section',
  templateUrl: './method-payments-section.component.html',
  styleUrls: ['./method-payments-section.component.scss']
})
export class MethodPaymentsSectionComponent extends SectionBase implements OnInit {

  control: AbstractControl;
  isError: boolean = false;
  methodPaymentGroup: FormGroup;
  errorMessage: string = 'methodPaymentsError';

  PaymentMethod = PaymentMethod;

  private errorsHistory: string[] = [];

  get showPaymentInfo(): boolean {
    return this.control.value  && this.control.value !== PaymentMethod.STANDARD_TRANSFER;
  }

  constructor(public methodPaymentsService: PaymentMethodsService,
              public googleAnalyticsService: GoogleAnalyticsEventsService,
              private ts: TranslateService,
              private formFieldService: FormFieldService,
              private metricsService: MetricsService) {
    super();
    this.control = new FormControl(methodPaymentsService.methodPayment, [Validators.required], null);
    this.methodPaymentGroup = new FormGroup({'methodPayment': this.control});
    this.methodPaymentsService.init();
  }

  get contractInfo(): string {
    const value = this.methodPaymentsService.methodPayment;
    if (value === PaymentMethod.STANDARD_TRANSFER) {
      return 'METHOD_PAYMENT_SECTION.buyContractInfo';
    } else {
      return 'METHOD_PAYMENT_SECTION.payContractInfo';
    }
  }

  ngOnInit() {
    this.initBean();
    this.createConfig();
    this.buildForm();
    this.initControlsChanges();
  }

  onClick() {
    setTimeout(() => {
      const methodConfig = this.methodPaymentsService.getMethodConfig(this.control.value);
      const fieldValue = (methodConfig && methodConfig.label) ? this.ts.instant(methodConfig.label) : null;
      if (fieldValue) {
        this.sendFieldClickGA4Event(fieldValue);
      }
    }, 0);
    this.parentSection.sendCheckoutElementClickEvent({
      fieldLabel: this.title
    });
  }

  initBean(): void {
  }

  initControlsChanges(): void {
    this.control.valueChanges.subscribe((value: string) => {
      this.methodPaymentsService.changeMethodPayment(value);
      this.metricsService.sendSimpleMetric(CustomMetricsName.METHOD_PAYMENT, MetricsType.RADIO, value);
      this.isError = false;
      this.onFieldChange(null);
    })
  }

  createConfig(): void {
    this.formConfig = {
      formKey: 'METHOD_PAYMENT_SECTION',
      fieldsConfig: []
    }
  }

  submitSection(): void {
    super.submitSection();
    if (this.control.valid) {
      this.isError = false;
    } else {
      this.isError = true;
      this.onError();
    }
  }

  isSectionValid(): boolean {
    super.isSectionValid();
    return this.control.valid;
  }

  fillForm(data: any) {
    super.fillForm(data);
    if (data.stepKey === StepKey.THIRD_STEP) {
      this.control.setValue(this.sectionDataMock.paymentMethod);
    }
  }

  public areErrors(): boolean {
    return this.control.touched && this.control.invalid;
  }

  private sendFieldClickGA4Event(fieldValue: string): void {
    const payload: Ga4EventPayload = {
      calculator_field_name: this.ts.instant('METHOD_PAYMENT_SECTION.title'),
      calculator_field_value: fieldValue
    };
    this.googleAnalyticsService.send(GA4EventKey.FIELD_CLICK, payload);
  }

  private sendFieldErrorGA4Event(errorMsg: string): void {
    const payload: Ga4EventPayload = {
      calculator_field_name: this.ts.instant('METHOD_PAYMENT_SECTION.title'),
      calculator_error_message: errorMsg
    };
    this.googleAnalyticsService.send(GA4EventKey.FIELD_ERROR, payload);
  }

  private onError(): void {
    if (this.isError && !this.errorsHistory.includes(this.errorMessage)) {
      this.sendFieldErrorGA4Event(this.ts.instant(this.errorMessage));
      this.errorsHistory.push(this.errorMessage);
    }
  }
}
